import { type RequestPayload, router } from "@inertiajs/core";
import { EducationConfigForm } from "../../../components/reportConfig/form/EducationConfigForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Group } from "../../../models/group";
import type { YearContext } from "../../../models/yearContext";
import { report_configurations_path } from "../../../routes";

type EducationConfigCreateProps = {
  year_contexts: YearContext[];
  groups: Group[];
  semester: "1" | "2";
};

export default function EducationConfigCreate({ year_contexts, groups, semester }: EducationConfigCreateProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(report_configurations_path), values);
  return (
    <ContentShell title="Neue Bildungsbericht-Vorlage" onBack={() => router.get(pathWithYearContext(report_configurations_path))}>
      <EducationConfigForm
        semester={semester}
        saveButtonLabel="Erstellen"
        groups={groups}
        yearContexts={year_contexts}
        onSubmit={onSubmit}
      />
    </ContentShell>
  );
}
